module.exports = __webpack_public_path__ + "static/media/uy.a15df864.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/uy.svg
// module id = 279
// module chunks = 0